export default __webpack_public_path__ + "static/media/ios.2b5aac01.webp";